const ThemeTooling = {
  hexCodeColorToRGB: (hexCode) => {
    if(hexCode==null || hexCode=="") {
      return "";
    }
    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hexCode);
    return result ? {
      r: parseInt(result[1], 16),
      g: parseInt(result[2], 16),
      b: parseInt(result[3], 16)
    } : null;
  },
};

export default ThemeTooling;


// WEBPACK FOOTER //
// ./source/tooling/themeTooling.js